// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2ezky","upload":"Small_upload__1-EeZ","imageWrap":"Small_imageWrap__1HXu-","removeBtn":"Small_removeBtn__3B_Vz"};